import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {ApiIdsWithNoDelete, DistributionAccount} from '../../distribution-account/distribution-account.model';
import {selectTargetError} from '../../target/target.reducer';
import {TargetService} from '../../target/target.service';
import {Segment} from '../segment.model';
import {SubSink} from 'subsink';
import {Observable} from 'rxjs';
import {ActionsSubject, Store} from '@ngrx/store';
import {selectSegmentDetails} from '../segments.state';
import {map} from 'rxjs/operators';
import {ofType} from '@ngrx/effects';
import {targetUnshared} from '../../target/target.state';

@Component({
  selector: 'app-segment-info-delete-target',
  template: `
    <button mat-icon-button
            id="button-dialog-close"
            class="mat-icon-button-small"
            data-cy="button-dialog-close"
            [mat-dialog-close]="true">
      <mat-icon>clear</mat-icon>
    </button>
    <h5 mat-dialog-title>Remove Share</h5>
    <ng-container *ngIf="segment$ | async as segment">
      <div mat-dialog-content class="mat-body-1">
        <p *ngIf="errorMessage" id="error-feedback" class="error">{{errorMessage}}</p>
        <p>The following share will be removed:</p>
        <p>Account: <b>{{account?.description}}</b><br/>
          Segment: <b>{{segment?.name}}</b></p>
        <p *ngIf="apiCannotUnshareSegment" style="color: red;">
          This share will be removed only in DMP. You will have to remove the share from the target account
          explicitly.</p>
        <p>Do you really want to proceed?</p>
      </div>
      <div mat-dialog-actions>
        <button id="button-delete-cancel" color="primary" mat-raised-button [mat-dialog-close]="true">Cancel</button>
        <button data-cy="button-delete-submit"
                id="button-delete-submit"
                color="warn"
                mat-raised-button
                (click)="delete(segment.id)">Delete
        </button>
      </div>
    </ng-container>
  `
})
export class SegmentRemoveShareDialogComponent implements OnInit, OnDestroy {

  // will be set manually from account.component.ts after open the dialog.
  account!: DistributionAccount;
  segment$: Observable<Segment | undefined> = this.store.select(selectSegmentDetails).pipe(map(seg => seg?.segment));
  errorMessage = '';
  apiCannotUnshareSegment = false;
  private subsink = new SubSink();

  constructor(private dialogRef: MatDialogRef<SegmentRemoveShareDialogComponent>,
              private targetsActions: TargetService,
              private store: Store,
              private actions: ActionsSubject) {
  }

  ngOnInit() {
    this.apiCannotUnshareSegment = ApiIdsWithNoDelete.includes(this.account.apiId);
    this.subsink.sink = this.actions
      .pipe(ofType(targetUnshared))
      .subscribe(_ => {
        this.dialogRef.close();
      });
    this.subsink.sink = this.store.select(selectTargetError)
      .subscribe(error => {
        if (!!error) {
          this.errorMessage = `Remove failed, cause: ${error.message}`;
        }
      });
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  delete(id: number) {
    this.targetsActions.unshareSegment(this.account.id, id);
  }
}
